// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c08708ad","703":"dbe124e7","787":"beca3f5d"}[chunkId] + ".chunk.js";
};